import { createApi } from '@reduxjs/toolkit/query/react';
import { customFetchBase } from './helpers/customFetchBase.js';
import { type BiblePassageData, type Bible } from '@soulhx/fs-common';
import { providesList } from './helpers/rtk-helpers.js';

export interface GetPassageRequest {
  bibleId: string;
  passageId: string;
}

export const bibleApi = createApi({
  reducerPath: 'bible-api',
  baseQuery: customFetchBase,
  tagTypes: ['bibles', 'passages'],
  endpoints: (builder) => ({
    getAllBibles: builder.query<Bible[], void>({
      query: () => '/read/bible-api/bibles',
      providesTags: (result) => providesList(result, 'bibles'),
    }),
    searchBibles: builder.mutation<Bible[], string>({
      query: (searchText) => ({
        url: '/read/bible-api/bibles/search',
        method: 'POST',
        body: { searchText },
      }),
    }),
    getPassage: builder.query<BiblePassageData, GetPassageRequest>({
      query: (requestObj) => `/read/bible-api/passage/${requestObj.bibleId}/${requestObj.passageId}`,
      providesTags: (result) => (result ? providesList([result], 'passages') : []),
    }),
  }),
});

export const {
  useGetAllBiblesQuery,
  useLazyGetAllBiblesQuery,
  useSearchBiblesMutation,
  useGetPassageQuery,
  useLazyGetPassageQuery,
} = bibleApi;
